module.exports = __webpack_public_path__ + "static/fonts/Mont-BlackItalic.7609929.eot";